import React, { useState, useEffect, useRef, useCallback } from 'react';
import axios from 'axios';
import API, { getUploadUrl } from '../../services/api';
import useToast from './useToast';

const authH      = () => ({ Authorization: `Bearer ${localStorage.getItem('adminToken')}` });
const isDemoMode = () => localStorage.getItem('adminMode') === 'demo';

function formatBytes(b) {
  if (!b)           return '0 B';
  if (b < 1024)     return b + ' B';
  if (b < 1048576)  return (b/1024).toFixed(1) + ' KB';
  return (b/1048576).toFixed(1) + ' MB';
}

/* Demo media library */
const DEMO_UPLOADS = [
  { _id:'u1',  filename:'clinical-leader.jpg',   originalName:'clinical-leader.jpg',   mimetype:'image/jpeg', size:245760,  type:'image', url:'/uploads/images/clinical-leader.jpg',   createdAt: new Date(Date.now()-1*86400000).toISOString(), imageUrl:'https://images.unsplash.com/photo-1631217868264-e5b90bb7e133?w=280&h=280&fit=crop&q=80' },
  { _id:'u2',  filename:'hr-strategist.jpg',      originalName:'hr-strategist.jpg',      mimetype:'image/jpeg', size:312000,  type:'image', url:'/uploads/images/hr-strategist.jpg',      createdAt: new Date(Date.now()-2*86400000).toISOString(), imageUrl:'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=280&h=280&fit=crop&q=80' },
  { _id:'u3',  filename:'education-leader.jpg',   originalName:'education-leader.jpg',   mimetype:'image/jpeg', size:198400,  type:'image', url:'/uploads/images/education-leader.jpg',   createdAt: new Date(Date.now()-3*86400000).toISOString(), imageUrl:'https://images.unsplash.com/photo-1580582932707-520aed937b7b?w=280&h=280&fit=crop&q=80' },
  { _id:'u4',  filename:'infrastructure.jpg',     originalName:'infrastructure.jpg',     mimetype:'image/jpeg', size:425600,  type:'image', url:'/uploads/images/infrastructure.jpg',     createdAt: new Date(Date.now()-4*86400000).toISOString(), imageUrl:'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=280&h=280&fit=crop&q=80' },
  { _id:'u5',  filename:'women-leaders.jpg',      originalName:'women-leaders.jpg',      mimetype:'image/jpeg', size:287300,  type:'image', url:'/uploads/images/women-leaders.jpg',      createdAt: new Date(Date.now()-5*86400000).toISOString(), imageUrl:'https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=280&h=280&fit=crop&q=80' },
  { _id:'u6',  filename:'visionary-leader.jpg',   originalName:'visionary-leader.jpg',   mimetype:'image/jpeg', size:310200,  type:'image', url:'/uploads/images/visionary-leader.jpg',   createdAt: new Date(Date.now()-6*86400000).toISOString(), imageUrl:'https://images.unsplash.com/photo-1556157382-97eda2f9e2bf?w=280&h=280&fit=crop&q=80' },
  { _id:'u7',  filename:'womens-day.jpg',         originalName:'womens-day.jpg',         mimetype:'image/jpeg', size:198000,  type:'image', url:'/uploads/images/womens-day.jpg',         createdAt: new Date(Date.now()-7*86400000).toISOString(), imageUrl:'https://images.unsplash.com/photo-1607746882042-944635dfe10e?w=280&h=280&fit=crop&q=80' },
  { _id:'u8',  filename:'business-leader.jpg',    originalName:'business-leader.jpg',    mimetype:'image/jpeg', size:267000,  type:'image', url:'/uploads/images/business-leader.jpg',    createdAt: new Date(Date.now()-8*86400000).toISOString(), imageUrl:'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=280&h=280&fit=crop&q=80' },
  { _id:'u9',  filename:'magazine-2026.pdf',      originalName:'Magazine-Issue-2026.pdf',mimetype:'application/pdf', size:3145728, type:'pdf',  url:'/uploads/pdfs/magazine-2026.pdf',  createdAt: new Date(Date.now()-9*86400000).toISOString()  },
  { _id:'u10', filename:'annual-report.pdf',      originalName:'Annual-Report-2025.pdf', mimetype:'application/pdf', size:5242880, type:'pdf',  url:'/uploads/pdfs/annual-report.pdf',  createdAt: new Date(Date.now()-10*86400000).toISOString() },
  { _id:'u11', filename:'empowering-women.jpg',   originalName:'empowering-women.jpg',   mimetype:'image/jpeg', size:234000,  type:'image', url:'/uploads/images/empowering-women.jpg',   createdAt: new Date(Date.now()-11*86400000).toISOString(), imageUrl:'https://images.unsplash.com/photo-1529665253569-6d01c0eaf7b6?w=280&h=280&fit=crop&q=80' },
  { _id:'u12', filename:'retirement-plan.jpg',    originalName:'retirement-plan.jpg',    mimetype:'image/jpeg', size:189000,  type:'image', url:'/uploads/images/retirement-plan.jpg',    createdAt: new Date(Date.now()-12*86400000).toISOString(), imageUrl:'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=280&h=280&fit=crop&q=80' },
];

let demoUpCounter = 400;

export default function AdminUploads() {
  const [uploads,    setUploads]    = useState([]);
  const [loading,    setLoading]    = useState(true);
  const [typeFilter, setTypeFilter] = useState('all');
  const [search,     setSearch]     = useState('');
  const [selected,   setSelected]   = useState([]);
  const [uploading,  setUploading]  = useState(false);
  const [uploadPct,  setUploadPct]  = useState(0);
  const [dragOver,   setDragOver]   = useState(false);
  const [viewItem,   setViewItem]   = useState(null);
  const [page,       setPage]       = useState(1);
  const PER = 18;
  const fileRef = useRef();
  const { addToast, ToastContainer } = useToast();

  /* ── Fetch ── */
  const fetchUploads = async () => {
    setLoading(true);
    if (isDemoMode()) {
      setTimeout(() => { setUploads([...DEMO_UPLOADS]); setLoading(false); }, 400);
      return;
    }
    try {
      const r = await API.get('/upload', { headers: authH() });
      setUploads(r.data.data?.length ? r.data.data : [...DEMO_UPLOADS]);
    } catch { setUploads([...DEMO_UPLOADS]); }
    finally  { setLoading(false); }
  };

  useEffect(() => { fetchUploads(); }, []);

  /* ── Upload ── */
  const handleFiles = async (files) => {
    if (!files || !files.length) return;
    const fileArr = Array.from(files);

    if (isDemoMode()) {
      setUploading(true);
      for (let i = 0; i <= 100; i += 20) {
        await new Promise(r => setTimeout(r, 120));
        setUploadPct(i);
      }
      const newUploads = fileArr.map(f => ({
        _id: `demo-u${++demoUpCounter}`,
        filename: f.name,
        originalName: f.name,
        mimetype: f.type,
        size: f.size,
        type: f.type === 'application/pdf' ? 'pdf' : 'image',
        url: f.type === 'application/pdf' ? `/uploads/pdfs/${f.name}` : `/uploads/images/${f.name}`,
        imageUrl: f.type.startsWith('image/') ? URL.createObjectURL(f) : null,
        createdAt: new Date().toISOString(),
      }));
      setUploads(prev => [...newUploads, ...prev]);
      addToast(`${fileArr.length} file${fileArr.length>1?'s':''} uploaded (demo)`, 'success');
      setUploading(false); setUploadPct(0);
      return;
    }

    setUploading(true); setUploadPct(0);
    try {
      if (fileArr.length === 1) {
        const fd = new FormData();
        fd.append('file', fileArr[0]);
        const isPdf = fileArr[0].type === 'application/pdf';
        await API.post(`/upload/${isPdf?'pdf':'image'}`, fd, {
          headers: { ...authH(), 'Content-Type':'multipart/form-data' },
          onUploadProgress: e => setUploadPct(Math.round(e.loaded*100/e.total)),
        });
      } else {
        const fd = new FormData();
        fileArr.forEach(f => fd.append('files', f));
        await API.post('/upload/multiple', fd, {
          headers: { ...authH(), 'Content-Type':'multipart/form-data' },
          onUploadProgress: e => setUploadPct(Math.round(e.loaded*100/e.total)),
        });
      }
      addToast(`${fileArr.length} file${fileArr.length>1?'s':''} uploaded!`, 'success');
      fetchUploads();
    } catch (err) {
      addToast(err.response?.data?.message || 'Upload failed', 'error');
    } finally { setUploading(false); setUploadPct(0); }
  };

  const handleDrop = useCallback(e => {
    e.preventDefault(); setDragOver(false);
    handleFiles(e.dataTransfer.files);
  }, []);

  /* ── Delete ── */
  const handleDelete = async (id) => {
    if (!window.confirm('Delete this file permanently?')) return;
    if (isDemoMode()) {
      setUploads(prev => prev.filter(u => u._id !== id));
      setSelected(prev => prev.filter(s => s !== id));
      addToast('File deleted (demo)', 'success');
      if (viewItem?._id === id) setViewItem(null);
      return;
    }
    try {
      await API.delete(`/upload/${id}`, { headers: authH() });
      addToast('File deleted', 'success');
      setUploads(prev => prev.filter(u => u._id !== id));
      setSelected(prev => prev.filter(s => s !== id));
      if (viewItem?._id === id) setViewItem(null);
    } catch { addToast('Delete failed', 'error'); }
  };

  const handleBulkDelete = async () => {
    if (!selected.length) return;
    if (!window.confirm(`Permanently delete ${selected.length} files?`)) return;
    if (isDemoMode()) {
      setUploads(prev => prev.filter(u => !selected.includes(u._id)));
      addToast(`${selected.length} files deleted (demo)`, 'success');
      setSelected([]); return;
    }
    let deleted = 0;
    for (const id of selected) {
      try { await API.delete(`/upload/${id}`, { headers: authH() }); deleted++; }
      catch {}
    }
    addToast(`${deleted} file${deleted!==1?'s':''} deleted`, 'success');
    setSelected([]); fetchUploads();
  };

  /* ── Selection ── */
  const toggleSel  = id => setSelected(p => p.includes(id) ? p.filter(x=>x!==id) : [...p,id]);
  const selectAll  = () => setSelected(filtered.map(u=>u._id));
  const clearSel   = () => setSelected([]);

  const copyUrl = (url) => {
    const full = getUploadUrl(url);
    navigator.clipboard.writeText(full).then(() => addToast('URL copied!', 'info'));
  };

  /* ── Filter ── */
  const filtered = uploads.filter(u =>
    (typeFilter==='all' || u.type===typeFilter) &&
    (!search || u.originalName.toLowerCase().includes(search.toLowerCase()))
  );
  const pages = Math.ceil(filtered.length / PER);
  const paged = filtered.slice((page-1)*PER, page*PER);

  /* ── Derived stats ── */
  const totalSize = uploads.reduce((s,u) => s+(u.size||0), 0);
  const imgCount  = uploads.filter(u=>u.type==='image').length;
  const pdfCount  = uploads.filter(u=>u.type==='pdf').length;

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">Uploads &amp; Media</h1>
          <p className="page-subtitle">
            {uploads.length} files · {imgCount} images · {pdfCount} PDFs · {formatBytes(totalSize)} total
          </p>
        </div>
        <div className="page-actions">
          {selected.length > 0 && (
            <button className="btn btn-danger" onClick={handleBulkDelete}>
              🗑️ Delete {selected.length} selected
            </button>
          )}
          <button className="btn btn-primary" onClick={() => fileRef.current?.click()}>
            ⬆️ Upload Files
          </button>
          <input ref={fileRef} type="file" multiple
            accept="image/jpeg,image/png,image/webp,image/gif,application/pdf"
            style={{ display:'none' }}
            onChange={e => handleFiles(e.target.files)}/>
        </div>
      </div>

      {/* Stats row */}
      <div className="stats-grid" style={{ marginBottom:20 }}>
        {[
          { label:'Total Files',  val: uploads.length, accent:'#c9a84c', icon:'🗂️' },
          { label:'Images',       val: imgCount,        accent:'#60a5fa', icon:'🖼️'  },
          { label:'PDFs',         val: pdfCount,        accent:'#f87171', icon:'📄'  },
          { label:'Total Size',   val: formatBytes(totalSize), accent:'#4ade80', icon:'💾', isStr:true },
        ].map(s => (
          <div key={s.label} className="stat-card"
            style={{ '--accent':s.accent, '--icon-bg':`${s.accent}18` }}>
            <div className="stat-card-icon" style={{ fontSize:'1.3rem' }}>{s.icon}</div>
            <div className="stat-card-val" style={{ fontSize: s.isStr?'1.4rem':'2rem' }}>
              {loading ? '—' : s.val}
            </div>
            <div className="stat-card-lbl">{s.label}</div>
          </div>
        ))}
      </div>

      {/* Drop Zone */}
      <div
        className={`drop-zone${dragOver?' drag-over':''}`}
        style={{ marginBottom:24, cursor:'pointer', position:'relative' }}
        onDragOver={e => { e.preventDefault(); setDragOver(true); }}
        onDragLeave={() => setDragOver(false)}
        onDrop={handleDrop}
        onClick={() => fileRef.current?.click()}
      >
        <div className="drop-icon">
          <svg width="28" height="28" fill="none" viewBox="0 0 24 24" stroke="#c9a84c" strokeWidth="1.6">
            <path strokeLinecap="round" strokeLinejoin="round"
              d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"/>
          </svg>
        </div>
        <div className="drop-title">
          {dragOver ? '✨ Release to upload' : 'Drag & drop files here, or click to browse'}
        </div>
        <div className="drop-sub">
          Images (JPEG, PNG, WEBP, GIF) &amp; PDFs · Up to 20 MB each · Multiple files supported
        </div>
        {uploading && (
          <div className="upload-progress" style={{ maxWidth:400, margin:'16px auto 0' }}>
            <div className="progress-label">
              <span>Uploading…</span><span style={{ fontWeight:700, color:'var(--gold)' }}>{uploadPct}%</span>
            </div>
            <div className="progress-bar-wrap">
              <div className="progress-bar" style={{ width:`${uploadPct}%` }}/>
            </div>
          </div>
        )}
      </div>

      {/* Media Library */}
      <div className="table-card">
        <div className="table-header">
          <div style={{ display:'flex', alignItems:'center', gap:12, flexWrap:'wrap' }}>
            <span className="table-title">Media Library</span>
            {selected.length > 0 && (
              <span className="badge badge-gold">{selected.length} selected</span>
            )}
          </div>
          <div className="table-controls" style={{ flexWrap:'wrap', gap:8 }}>
            {selected.length > 0 ? (
              <button className="btn btn-sm btn-secondary" onClick={clearSel}>Clear selection</button>
            ) : filtered.length > 0 && (
              <button className="btn btn-sm btn-secondary" onClick={selectAll}>Select all</button>
            )}
            <div className="search-box">
              <svg width="15" height="15" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                <circle cx="11" cy="11" r="8"/><path strokeLinecap="round" d="M21 21l-4.35-4.35"/>
              </svg>
              <input placeholder="Search files…" value={search}
                onChange={e => { setSearch(e.target.value); setPage(1); }}/>
            </div>
            <div style={{ display:'flex', gap:4 }}>
              {['all','image','pdf'].map(t => (
                <button key={t}
                  className={`btn btn-sm${typeFilter===t?' btn-primary':' btn-secondary'}`}
                  onClick={() => { setTypeFilter(t); setPage(1); setSelected([]); }}>
                  {t==='all' ? 'All' : t==='image' ? '🖼 Images' : '📄 PDFs'}
                </button>
              ))}
            </div>
          </div>
        </div>

        {loading ? (
          <div style={{ padding:24 }}>
            <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(130px,1fr))', gap:12 }}>
              {Array.from({length:12}).map((_,i) => (
                <div key={i} style={{ aspectRatio:'1', background:'var(--card2)', borderRadius:6,
                  animation:'pulse 1.4s infinite' }}/>
              ))}
            </div>
          </div>
        ) : paged.length === 0 ? (
          <div className="empty-state">
            <div className="empty-icon">
              <svg width="26" height="26" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5">
                <path strokeLinecap="round" strokeLinejoin="round"
                  d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"/>
              </svg>
            </div>
            <div className="empty-title">No files found</div>
            <div className="empty-sub">
              {search ? 'No files match your search.' : 'Upload files using the drop zone above.'}
            </div>
          </div>
        ) : (
          <div style={{ padding:'16px 20px' }}>
            <div className="media-library">
              {paged.map(u => {
                const isSel = selected.includes(u._id);
                const imgSrc = u.imageUrl || (u.type==='image' ? getUploadUrl(u.url) : null);
                return (
                  <div
                    key={u._id}
                    className={`media-item${isSel?' selected':''}`}
                    onClick={() => toggleSel(u._id)}
                    title={u.originalName}
                  >
                    {u.type === 'image' && imgSrc ? (
                      <img src={imgSrc} alt={u.originalName} loading="lazy"
                        onError={e => { e.target.style.display='none'; }}/>
                    ) : (
                      <div className="media-pdf">
                        <div className="media-pdf-icon">📄</div>
                        <div className="media-pdf-name">{u.originalName}</div>
                      </div>
                    )}

                    <div className="media-item-info">
                      <div className="media-item-name">{u.originalName}</div>
                      <div className="media-item-size">{formatBytes(u.size)}</div>
                    </div>
                    <div className="media-check">✓</div>

                    {/* Hover action bar */}
                    <div className="media-hover-bar"
                      onClick={e => e.stopPropagation()}
                      style={{
                        position:'absolute', top:4, left:4, right:4,
                        display:'flex', gap:3,
                        opacity:0, transition:'opacity .18s',
                      }}>
                      <button onClick={() => copyUrl(u.url)}
                        style={{ flex:1, padding:'4px 0', background:'rgba(0,0,0,.78)',
                          border:'none', borderRadius:3, color:'#fff',
                          fontSize:'.6rem', fontWeight:600, cursor:'pointer' }}>
                        Copy URL
                      </button>
                      <button onClick={() => setViewItem(u)}
                        style={{ flex:1, padding:'4px 0', background:'rgba(0,0,0,.78)',
                          border:'none', borderRadius:3, color:'#fff',
                          fontSize:'.6rem', fontWeight:600, cursor:'pointer' }}>
                        View
                      </button>
                      <button onClick={() => handleDelete(u._id)}
                        style={{ padding:'4px 7px', background:'rgba(248,113,113,.8)',
                          border:'none', borderRadius:3, color:'#fff',
                          fontSize:'.6rem', fontWeight:700, cursor:'pointer' }}>
                        ✕
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {pages > 1 && (
          <div className="pagination">
            <span className="pagination-info">
              Showing {(page-1)*PER+1}–{Math.min(page*PER,filtered.length)} of {filtered.length}
            </span>
            <div className="pagination-btns">
              <button className="page-btn" disabled={page===1}     onClick={()=>setPage(p=>p-1)}>‹</button>
              {Array.from({length:Math.min(pages,7)},(_,i)=>i+1).map(p=>(
                <button key={p} className={`page-btn${p===page?' active':''}`}
                  onClick={()=>setPage(p)}>{p}</button>
              ))}
              <button className="page-btn" disabled={page===pages} onClick={()=>setPage(p=>p+1)}>›</button>
            </div>
          </div>
        )}
      </div>

      {/* File detail modal */}
      {viewItem && (
        <div className="modal-root" onClick={() => setViewItem(null)}>
          <div className="modal-backdrop"/>
          <div className="modal-panel modal-center"
            style={{ maxWidth:580, height:'auto' }}
            onClick={e => e.stopPropagation()}>
            <div className="modal-head">
              <h2>File Details</h2>
              <button className="modal-close" onClick={() => setViewItem(null)}>✕</button>
            </div>
            <div className="modal-body">
              {/* Preview */}
              {viewItem.type === 'image' ? (
                <img
                  src={viewItem.imageUrl || getUploadUrl(viewItem.url)}
                  alt={viewItem.originalName}
                  style={{ width:'100%', maxHeight:320, objectFit:'contain',
                    borderRadius:6, background:'var(--bg3)', marginBottom:20, display:'block' }}
                  onError={e => e.target.style.display='none'}/>
              ) : (
                <div style={{ width:'100%', height:160, background:'rgba(248,113,113,.08)',
                  border:'1px solid rgba(248,113,113,.2)', borderRadius:6,
                  display:'flex', flexDirection:'column', alignItems:'center',
                  justifyContent:'center', gap:10, marginBottom:20 }}>
                  <span style={{ fontSize:'3rem' }}>📄</span>
                  <span style={{ color:'var(--white70)', fontSize:'.9rem' }}>PDF Document</span>
                </div>
              )}

              {/* Meta */}
              <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
                {[
                  { k:'File Name',  v: viewItem.originalName  },
                  { k:'Type',       v: viewItem.mimetype       },
                  { k:'Size',       v: formatBytes(viewItem.size) },
                  { k:'Uploaded',   v: new Date(viewItem.createdAt).toLocaleString() },
                  { k:'URL',        v: getUploadUrl(viewItem.url) },
                ].map(({ k, v }) => (
                  <div key={k} style={{ display:'flex', gap:10, fontSize:'.83rem' }}>
                    <span style={{ color:'var(--white40)', width:90, flexShrink:0, fontWeight:600 }}>{k}</span>
                    <span style={{ color:'var(--white70)', wordBreak:'break-all', lineHeight:1.5 }}>{v}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="modal-foot">
              <button className="btn btn-danger btn-sm"
                onClick={() => { handleDelete(viewItem._id); setViewItem(null); }}>
                🗑️ Delete File
              </button>
              <button className="btn btn-secondary"
                onClick={() => copyUrl(viewItem.url)}>
                📋 Copy URL
              </button>
              {viewItem.url && (
                <a href={getUploadUrl(viewItem.url)}
                  target="_blank" rel="noopener noreferrer"
                  className="btn btn-primary">
                  Open File ↗
                </a>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Hover bar reveal style */}
      <style>{`
        .media-item:hover .media-hover-bar { opacity: 1 !important; }
        @keyframes pulse { 0%,100%{opacity:1} 50%{opacity:.4} }
      `}</style>

      <ToastContainer/>
    </div>
  );
}
